import { createSlice } from '@reduxjs/toolkit'

export const UserSlice = createSlice({
    name: 'user',
    initialState: {
        user_list: [],
        anylysts_list: [],
        sellers_list: [],
        salesperson_list: [],
        affiliates_list: [],
        is_exists_in_stripe: true
    },
    reducers: {
        setUsersList: (state, action) => {
            state.user_list = action.payload;
        },
        setAlalystsList: (state, action) => {
            state.anylysts_list = action.payload
        },
        setSellersList: (state, action) => {
            state.sellers_list = action.payload
        },
        setSalespersonList: (state, action) => {
            state.salesperson_list = action.payload
        },
        setAffiliatesList: (state, action) => {
            state.affiliates_list = action.payload
        },
        setIsExistsInStripe: (state, action) => {
            state.is_exists_in_stripe = action.payload
        }
    },
})

export const {
    setUsersList,
    setAlalystsList,
    setSellersList,
    setSalespersonList,
    setIsExistsInStripe,
    setAffiliatesList
} = UserSlice.actions;

export default UserSlice.reducer;
